module.exports = __webpack_public_path__ + "img/element-icons-logo-hbomax.7b4b42aa.svg";